import {
  authenticatedDelete,
  authenticatedGet,
  authenticatedPost,
} from "../base/util/api";
import { logError, showError, showSuccess } from "../base/util/alerts";
import { loadAllControllers, loadMutes } from "../display/controllerActions";
import { sha256Hex } from "../base/util/sha256";

export function AddAllUsersAdmin(userList) {
  return {
    type: "ADD_ALLUSERS_ADMIN_SETTINGS",
    userListAdmin: userList,
  };
}

export const HIDE_SCALE = "HIDE_SCALE";
export const hideScale = (id) => {
  return (dispatch) => {
    authenticatedPost(`scales/${id}/hide`)
      .then(() => {
        dispatch({
          type: HIDE_SCALE,
          id,
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const UNHIDE_SCALE = "UNHIDE_SCALE";
export const unhideScale = (id) => {
  return (dispatch) => {
    authenticatedPost(`scales/${id}/unhide`)
      .then(() => {
        dispatch({
          type: UNHIDE_SCALE,
          id,
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const addNotification = (type, address) => {
  return (dispatch) => {
    authenticatedPost("notification", {
      type,
      address,
    })
      .then((res) => {
        console.log("VVV");
        console.log(res);
        showSuccess("Erfolgreich gespeichert.");
        dispatch({
          type: ADD_NOTIFICATION,
          notification: {
            type,
            address,
            id: res.id,
          },
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const removeNotification = (id) => {
  return (dispatch) => {
    authenticatedPost(`notification/${id}/remove`)
      .then((msg) => {
        showSuccess(msg.message);
        dispatch({
          type: REMOVE_NOTIFICATION,
          id,
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const testNotification = (id) => {
  return () => {
    authenticatedPost(`notification/${id}/test`)
      .then((msg) => {
        showSuccess(msg.message);
      })
      .catch((msg) => showError(msg.message));
  };
};

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const loadNotifications = () => {
  return (dispatch) => {
    authenticatedGet("notification")
      .then((notifications) => {
        dispatch({
          type: SET_NOTIFICATIONS,
          notifications,
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const SET_CONTROLLER_WATCHES = "SET_CONTROLLER_WATCHES";
export const loadControllerWatches = () => {
  return (dispatch) => {
    authenticatedGet("controller/watches")
      .then((watches) => {
        dispatch({
          type: SET_CONTROLLER_WATCHES,
          watches,
        });
      })
      .catch((msg) => showError(msg.message));
  };
};

export const addControllerWatch = (code) => {
  return (dispatch) => {
    return authenticatedPost("controller/watches", { code })
      .then((res) => {
        showSuccess(res.message);
        dispatch(loadControllerWatches());
      })
      .catch((res) => showError(res.message));
  };
};

export const removeControllerWatch = (controllerId) => {
  return (dispatch) => {
    authenticatedDelete(`controller/watches/${controllerId}`)
      .then((res) => {
        showSuccess(res.message);
        dispatch(loadControllerWatches());
      })
      .catch((res) => showError(res.message));
  };
};

export const RESET_LIMIT = "RESET_LIMIT";
export const resetLimit = (controllerId) => {
  return (dispatch) => {
    authenticatedPost(`admin/controller/${controllerId}/resetNotificationCount`)
      .then((msg) => {
        showSuccess(msg.message);
        dispatch({
          type: RESET_LIMIT,
          controllerId,
        });
        dispatch(loadAllControllers());
      })
      .catch((msg) => showError(msg.message));
  };
};

export const SET_JOBS = "SET_JOBS";
export const loadJobs = () => {
  return (dispatch) => {
    return authenticatedGet("jobs")
      .then((jobs) => {
        dispatch({
          type: SET_JOBS,
          jobs,
        });
        return Promise.resolve(jobs);
      })
      .catch((msg) => {
        showError(msg.message);
        logError(msg.message);
        return Promise.reject();
      });
  };
};

export const submitJob = (type, options) => {
  return (dispatch) => {
    authenticatedPost("jobs", {
      type,
      ...options,
    })
      .then((msg) => {
        showSuccess(msg.message);
        dispatch(loadJobs());
      })
      .catch((msg) => showError(msg.message));
  };
};

export const submitWeatherUpdateJob = (controllerId, from, to) =>
  submitJob("WEATHER_UPDATE", {
    controllerId,
    from,
    to,
  });

export const muteNotifications = (idcontroller, type, enddate) => {
  return (dispatch) => {
    authenticatedPost(
      `notification/mute?idcontroller=${idcontroller}&notificationType=${type}&enddate=${enddate}`,
    )
      .then((msg) => {
        dispatch(loadMutes(idcontroller));
        showSuccess(msg.message);
      })
      .catch((msg) => showError(msg.message));
  };
};

export const unmuteNotifications = (idcontroller, type) => {
  return (dispatch) => {
    authenticatedPost(
      `notification/unmute?idcontroller=${idcontroller}&notificationType=${type}`,
    )
      .then((msg) => {
        dispatch(loadMutes(idcontroller));
        showSuccess(msg.message);
      })
      .catch((msg) => showError(msg.message));
  };
};

export const createControllers = (controllers, affiliation) => {
  return () => {
    return authenticatedPost(
      `admin/affiliation/${affiliation}/controllers`,
      controllers,
    )
      .then((msg) => showSuccess(msg.message))
      .catch((msg) => showError(msg.message));
  };
};

export const loadUsers = () => {
  return (dispatch) => {
    authenticatedGet("admin/users")
      .then((users) => dispatch(AddAllUsersAdmin(users)))
      .catch((msg) => showError(msg.message));
  };
};

export const loadAffiliatedUsers = (affiliationId) => {
  return (dispatch) => {
    authenticatedGet("admin/affiliatedUsers?affiliationId=" + affiliationId)
      .then((users) => dispatch(AddAllUsersAdmin(users)))
      .catch((msg) => showError(msg.message));
  };
};

export const TOGGLE_USER_ACTIVE = "settings/user_active_toggle";
export const changeUserState = (userId) => {
  return (dispatch) => {
    authenticatedPost(`admin/user/${userId}/changestate`)
      .then(
        dispatch({
          type: TOGGLE_USER_ACTIVE,
          userId,
        }),
      )
      .then((msg) => showSuccess(msg.message))
      .catch((msg) => showError(msg.message));
  };
};

export const uploadFirmware = (version, file) => {
  return () => {
    let form = new FormData();
    form.append("version", version);
    form.append("data", file);

    const headers = new Headers();
    return fetch(window.location.origin + "/admin/firmware", {
      method: "POST",
      headers,
      credentials: "include",
      body: form,
    }).then((response) => {
      if (!response.ok) {
        response.json().then((msg) => showError(msg.message));
      } else {
        response.json().then((msg) => showSuccess(msg.message));
      }
    });
  };
};

export const getFirmware = () => {
  return () => {
    return authenticatedGet("admin/firmware");
  };
};

export const deleteFirmware = (version) => {
  return () => {
    return authenticatedDelete(`admin/firmware?version=${version}`);
  };
};

export const updateControllerFirmwares = (firmware, controllerIds) => {
  return (dispatch) => {
    authenticatedPost(
      `admin/controller/firmware?firmwareversion=${firmware}`,
      controllerIds.map((cId) => ({ id: cId })),
    )
      .then((msg) => {
        showSuccess(msg.message);
        return dispatch(loadAllControllers());
      })
      .catch((msg) => showError(msg.message));
  };
};

export const adminUpdateController = (id, values) => (dispatch) => {
  return authenticatedPost(`admin/controller/${id}`, values).catch((msg) =>
    showError(msg.message),
  );
};

export const registerUser = (registerModel) => async (dispatch) => {
  const hashedPassword = await sha256Hex(registerModel.user.password);
  return new Promise((resolve, reject) => {
    authenticatedPost("registration/user", {
      ...registerModel,
      user: {
        ...registerModel.user,
        password: hashedPassword,
      },
    })
      .then((user) => {
        dispatch({
          type: "LOGIN_SUCCESS",
          user,
        });
        return resolve(user);
      })
      .catch((data) => {
        showError(data.message);
        return reject(data);
      });
  });
};

export const SET_GLOBAL_SETTINGS = "settings/global/set/all";
export const setGlobalSettings = (settings) => ({
  type: SET_GLOBAL_SETTINGS,
  settings,
});

export const SET_GLOBAL_SETTING = "settings/global/set/one";
export const setGlobalSetting = (key, value) => ({
  type: SET_GLOBAL_SETTING,
  key,
  value,
});

export const fetchGlobalSettings = () => (dispatch) => {
  authenticatedGet("admin/settings")
    .then((settings) => dispatch(setGlobalSettings(settings)))
    .catch((msg) => showError(msg.message));
};

export const saveGlobalSettings = (settings) => (dispatch) => {
  authenticatedPost("admin/settings", settings)
    .then((msg) => {
      showSuccess(msg.message);
    })
    .catch((err) => showError(err.message));
};

export const createShare = (share) => (dispatch) => {
  authenticatedPost("share", share)
    .then((share) => dispatch(selectShare(share)))
    .catch((err) => showError(err.message));
};

export const fetchShares = () => (dispatch) => {
  return authenticatedGet("share")
    .then((shares) => dispatch(setShares(shares)))
    .catch((err) => showError(err.message));
};

export const deleteShare = (token) => (dispatch) => {
  return authenticatedDelete("share/" + token)
    .then((msg) => showSuccess(msg.message))
    .catch((err) => showError(err.message));
};

export const SHARES_SET = "SETTINGS_SHARES_SET";
export const setShares = (shares) => {
  return {
    type: SHARES_SET,
    shares,
  };
};

export const SHARE_SELECT = "SETTINGS_SHARE_SELECT";
export const selectShare = (share) => {
  return {
    type: SHARE_SELECT,
    share,
  };
};

export const CHART_STATE_SET = "CHART_STATE_SET";
export const saveChartState = (value) => ({
  type: CHART_STATE_SET,
  value,
});

export const createRegion = (region) => (dispatch) => {
  return authenticatedPost(
    "region",
    ("region/",
    {
      ...region,
      geojson: JSON.stringify(JSON.parse(region.geojson)),
    }),
  );
};

export const fetchPublicRegions = () => (dispatch) => {
  return authenticatedGet("public/region").then((regions) =>
    dispatch(setRegions(regions)),
  );
};

export const fetchAllRegions = () => (dispatch) => {
  return authenticatedGet("admin/region").then((regions) =>
    dispatch(setRegions(regions)),
  );
};

export const fetchUserRegions = () => (dispatch) => {
  return authenticatedGet("region").then((regions) =>
    dispatch(setRegions(regions)),
  );
};

export const updateRegion = (id, region) => (dispatch) => {
  return authenticatedPost("region/" + id, {
    ...region,
    geojson: JSON.stringify(JSON.parse(region.geojson)),
  });
};

export const deleteRegion = (id) => (dispatch) => {
  return authenticatedDelete("region/" + id);
};

export const REGIONS_SET = "SETTINGS_REGIONS_SET";
export const setRegions = (regions) => {
  return {
    type: REGIONS_SET,
    regions,
  };
};

export const updateUserProfile = (userId, profile) => (dispatch) => {
  return authenticatedPost(`admin/user/${userId}/profile`, profile);
};

export const FORWARDINGS_SET = "settings/forwardings/set";
export const setForwardings = (forwardings) => ({
  type: FORWARDINGS_SET,
  forwardings,
});

export const loadForwardings = (controllerId, channelId) => (dispatch) => {
  return authenticatedGet(
    `controller/${controllerId}/channel/${channelId}/forwarding`,
  ).then((fs) => dispatch(setForwardings(fs)));
};

export const saveForwarding = (controllerId, channelId, body) => (dispatch) => {
  return authenticatedPost(
    `controller/${controllerId}/channel/${channelId}/forwarding`,
    body,
  );
};

export const deleteForwarding = (forwardingId) => (dispatch) => {
  return authenticatedDelete(`controller/forwarding/${forwardingId}`);
};
